export default [
  {
    path: '/wifi-qr-generator',
    name: 'wifi-qr-generator',
    beforeEnter() {
      window.open('https://www.hostmatic.io/wifi-qr-generator/','_blank')
    }
  }
]
